import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ContentBox from '../../components/layout/ContentBox';
import { ColumnObject } from '../../components/layout/table/ZerpaTable';
import InstituteManageDetail from '../../components/institute/InstituteManageDetail';
import UserManagement from '../../components/user/UserManagement';

import { convertToQid } from '../../utilities/stringHelper';
import {
  fetchUsers,
  fetchInstitutes,
} from '../../redux/actions';
import { QuipUser, RootState } from '../../redux/types';
import { useAppDispatch } from '../../hooks/reduxHooks';

type MatchParams = {
  instituteId: string;
}

type ExtendedUser = QuipUser & {
  userId: string;
};

const columns: ColumnObject[] = [
  {
    keyName: '',
    text: 'select',
    type: 'checkbox',
  },
  {
    keyName: 'userId',
    text: 'Quip Id',
    sortable: true,
  },
  {
    keyName: 'title',
    text: <FormattedMessage id="trialdetails.title" />,
    sortable: true,
  },
  {
    keyName: 'firstname',
    text: <FormattedMessage id="userDetails.firstname" />,
    sortable: true,
  },
  {
    keyName: 'surname',
    text: <FormattedMessage id="userDetails.surname" />,
    sortable: true,
  },
  {
    keyName: 'email',
    text: <FormattedMessage id="userDetails.email" />,
    sortable: true,
  },
  {
    keyName: 'position',
    text: 'Position',
    sortable: true,
  },
  {
    keyName: 'instituteId',
    text: 'Institute Id',
    sortable: true,
  },
];

const InstituteUsersView: React.FC = () => {
  const params = useParams<MatchParams>();
  const { instituteId } = params;
  const dispatch = useAppDispatch();
  const usersById = useSelector((state: RootState) => state.users.byId);
  const allUserIds = useSelector((state: RootState) => state.users.allIds);
  const institutesById = useSelector((state: RootState) => state.institute.byId);
  const [filteredUsers, setFilteredUsers] = useState<ExtendedUser[]>();
  const instituteData = institutesById && institutesById[Number(instituteId)];

  useEffect(() => {
    if (!usersById && !allUserIds) {
      dispatch(fetchUsers());
    }
  }, [dispatch, usersById, allUserIds]);

  useEffect(() => {
    if (!institutesById) {
      dispatch(fetchInstitutes());
    }
  }, [dispatch, institutesById]);

  useEffect(() => {
    if (usersById) {
      const filtered: ExtendedUser[] = Object.values(usersById)
        .filter((u) => u.instituteId === Number(instituteId))
        .map((u) => ({
          ...u,
          userId: convertToQid(u.id, instituteData?.country || u.userCountry),
        } as ExtendedUser));
      setFilteredUsers(filtered);
    }
  }, [instituteData?.country, instituteId, usersById]);

  return (
    <>
      <ContentBox title={<FormattedMessage id="menu.institute" />}>
        {
          instituteData
          && <InstituteManageDetail institute={instituteData} />
        }
        <UserManagement
          userTableColumns={columns}
          userTableRows={filteredUsers}
        />
      </ContentBox>
    </>
  );
};

export default InstituteUsersView;
